﻿$.fn.dxCtrlHeureBox = function custom_dxCtrlHeureBox(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlheurebox dx-ctrl");
        this.createInstance(new cdxCtrlHeureBox(this, option));
    }
    return this;
}

window.cdxCtrlHeureBox = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }
    if (typeof option.label == 'undefined') option.label = "Heure"

    var dx = null;
    var $target = null
    function mConstruit() {
        container.empty();
        if (option.textLink) {
            if (option.disabled) {
                $target = $("<a >" + option.textLink.replace("%%heure%%", option.value) + "</a>").appendTo(container);
            } else {
                $target = $("<a href='javascript:void(0)'>" + option.textLink.replace("%%heure%%", option.value) + "</a>").appendTo(container);
                $target.on("click", function (e) {
                    if (!option.onClick || option.onClick()) mShowChoixHeure()
                })
            }

        } else {
            $target = $("<table style='cursor:pointer'/>").appendTo(container);
            var $Tr = $("<tr/>").appendTo($target);
            var $Td = $("<td style='width:1px'/>").appendTo($Tr);
            option.readOnly = true
            option.disabled = true
            if (!option.width) option.width = 52
            if (option.value < 10 && option.value.toString().length < 2) option.value = "0" + option.value.toString()
            dx = $("<div/>").appendTo($Td).dxTextBox(option).dxTextBox("instance")
            dx.element().css("cursor", "pointer");
            var $Td = $("<td style='width:1px;white-space:nowrap;text-align:left;'>h</td>").appendTo($Tr);

            $target.on("click", function () { mShowChoixHeure() });
        }

    }

    function mShowChoixHeure() {
        tt = $("<div/>").appendTo("body").dxCtrlTooltip({
            onHidden: function (e) { e.component.element().remove(); },
            target: $target,
            //width: 288,
            position: ((typeof position == 'undefined' || !position) ? "bottom" : position),
            contentTemplate: function (contentElement) {
                $("<div>" + option.label + "</div>").appendTo(contentElement)
                var $Table = $("<table/>").appendTo(contentElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "0h",
                    onClick: function (e) { mAddChiffre("00") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "1h",
                    onClick: function (e) { mAddChiffre("01") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "2h",
                    onClick: function (e) { mAddChiffre("02") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "3h",
                    onClick: function (e) { mAddChiffre("03") }
                })
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "4h",
                    onClick: function (e) { mAddChiffre("04") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "5h",
                    onClick: function (e) { mAddChiffre("05") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "6h",
                    onClick: function (e) { mAddChiffre("06") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "7h",
                    onClick: function (e) { mAddChiffre("07") }
                })
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "8h",
                    onClick: function (e) { mAddChiffre("08") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "9h",
                    onClick: function (e) { mAddChiffre("09") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "10h",
                    onClick: function (e) { mAddChiffre("10") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "11h",
                    onClick: function (e) { mAddChiffre("11") }
                })
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "12h",
                    onClick: function (e) { mAddChiffre("12") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "13h",
                    onClick: function (e) { mAddChiffre("13") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "14h",
                    onClick: function (e) { mAddChiffre("14") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "15h",
                    onClick: function (e) { mAddChiffre("15") }
                })
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "16h",
                    onClick: function (e) { mAddChiffre("16") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "17h",
                    onClick: function (e) { mAddChiffre("17") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "18h",
                    onClick: function (e) { mAddChiffre("18") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "19h",
                    onClick: function (e) { mAddChiffre("19") }
                })
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "20h",
                    onClick: function (e) { mAddChiffre("20") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "21h",
                    onClick: function (e) { mAddChiffre("21") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "22h",
                    onClick: function (e) { mAddChiffre("22") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxButton({
                    text: "23h",
                    onClick: function (e) { mAddChiffre("23") }
                })
            }
        }).dxCtrlTooltip("instance");
        tt.show();

        function mAddChiffre(chiffre) {
            tt.hide();
            option.value = chiffre
            if (option.onValueChanged) option.onValueChanged(option.value)
            if (dx) { dx.option("value", chiffre) } else { mConstruit() }
        }
    }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();

}